import { useSelector } from 'react-redux';
import React from 'react';
import MarketPreviews from 'app/shared/components/MarketPreviews';
import { gaEvents } from 'app/shared/constants/AnalyticsConstants';
import MarketTrendsCSEvents from 'app/shared/constants/MarketTrendsCSEvents';

import type { Market } from 'app/shared/types/Market';
import type { State } from 'app/shared/types/State';

interface TopMarketsProps {
  markets: Array<Market>;
  isSmallScreen: boolean;
  isMobile: boolean;
}

const TopMarkets: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<TopMarketsProps>>> = (
  props,
) => {
  const user = useSelector((state: State) => state.user);
  const { markets, isSmallScreen, isMobile } = props;

  return (
    <MarketPreviews
      markets={markets}
      heading="Top Rental Markets"
      subject="top markets"
      copyText="Based on current median rent"
      useFilters
      isSmallScreen={isSmallScreen}
      isMobile={isMobile}
      gaEvent={gaEvents.VIEW_TOP_MARKET}
      clickstreamEvent={MarketTrendsCSEvents.ViewTopMarket({ user })}
    />
  );
};

export default TopMarkets;
